// extracted by mini-css-extract-plugin
module.exports = {"header":"FutureDeliveries_header__3PR8G","oilType":"FutureDeliveries_oilType__3WsVi","createdDate":"FutureDeliveries_createdDate__23rid","count":"FutureDeliveries_count__3D6Jl"};